<template>
  <ui-dialog
    :isLoading="isLoading"
    :title="L10n('confirm-quote-approved')"
    :isVisible="true"
    @close="_closeDialog"
  >
    <form-editor
      :model="model"
      :data="data"
      ref="form"
    />
    <template v-slot:footer>
      <div class="activity-po-wo-wrap__footer">
        <button class="btn btn-border grey btn-size-s btn-mobile-full" @click="_closeDialog">
          {{L10n('close')}}
        </button>
        <button class="ml-sm-3 btn btn-border blue btn-size-s btn-mobile-full" @click="_onSubmit">
          {{L10n('confirm')}}
        </button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import { ServiceSalesOrders } from '@/services/SalesOrders'

export default {
  name: 'DialogQuoteApproved',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Shared' */ '@/components/Dialogs/Dialog'),
    'form-editor': () => import(/* webpackChunkName: 'Shared' */ './FormQuoteApproved')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    salesOrderIDList: {
      required: true
    }
  },
  created () {
    this._resetForm()
  },
  data () {
    return {
      data: {}
    }
  },
  methods: {
    model () {
      return {
        approvedForPaymentByEmployeeID: null
      }
    },
    _resetForm () {
      this.data = {}
    },
    _closeDialog () {
      this.$emit('onClose')
      this._resetForm()
    },
    async _onSubmit () {
      this.$emit('update:isLoading', true)
      const form = this.$refs.form
      return form
        .validate()
        .then(() => {
          return Promise.all(
            this.salesOrderIDList.map((id) => {
              return ServiceSalesOrders
                .patch({
                  id,
                  ...form.getData()
                })
                .then(() => {
                  this.$emit('onSuccess')
                  this._resetForm()
                })
                .catch((err) => {
                  this.requestErrorHandler(err)
                })
            })
          )
        })
        .finally(() => {
          this.$emit('update:isLoading', false)
        })
    }
  }
}
</script>
